<template>
    <CardPage :section="7" :page="7" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            This was a really messed up situation, but you turned it around with an assertive response. Great work! You are really getting the hang of assertive
            communication! If you are in need of medical services, check out the resource list. You’ve earned another sticker for completing that activity!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section7/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section7/sticker@earned', true);
        }
    }
};
</script>
